import { render, staticRenderFns } from "./OrderInfoBox.vue?vue&type=template&id=16350aa3&scoped=true&"
import script from "./OrderInfoBox.vue?vue&type=script&lang=js&"
export * from "./OrderInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoBox.vue?vue&type=style&index=0&id=16350aa3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16350aa3",
  null
  
)

export default component.exports